const title = ''
// 域名
const host = process.env.VUE_APP_BASE_API
// 后台的授权URL
// const wxAuthUrl = host + '/wx/pageAuth'
// // 与后台对接校验的字符串
// const wxSignature = 'Ms7uTc9sY7lwR0mf1G'

export default {
  title, host
}



// WEBPACK FOOTER //
// ./src/utils/globalConst.js